import { Controller } from 'stimulus';
import serializeFormToObject from '@/helpers/serializeFormToObject';
import delegatedEventListener from '@/helpers/delegatedEventListener';
import hasHistorySupport from '@/helpers/hasHistorySupport';

class FiltersController extends Controller {
  connect() {
    this.groupTargets.forEach((groupTarget) => {
      delegatedEventListener('change', 'input[type="checkbox"]', groupTarget, () => {
        this.onFilterChange();
      });
    });
  }

  onFilterChange() {
    const formData = serializeFormToObject(this.formTarget);

    formData.sort_by = this.sortSelectTarget.value;

    this.fetchPage(formData)
      .then((res) => {
        if (typeof res.products === 'undefined') {
          throw new Error('Products are missing');
        }

        this.outputProducts(res.products);

        if (typeof res.url !== 'undefined') {
          this.outputUrl(res.url);
        }

        if (typeof res.results !== 'undefined') {
          this.outputResults(res.results);
        }
      });
  }

  fetchPage(formData) {
    return new Promise((resolve, reject) => {
      const formUrl = this.formTarget.getAttribute('action');

      $.ajax({
        url: formUrl,
        data: formData,
        success: resolve,
        error: reject,
      });
    });
  }

  outputProducts(products) {
    this.runOffMainThread(() => {
      this.productsTarget.innerHTML = products;
    });
  }

  // eslint-disable-next-line class-methods-use-this
  runOffMainThread(cb) {
    if ('requestAnimationFrame' in window) {
      requestAnimationFrame(() => {
        requestAnimationFrame(cb);
      });
      return;
    }

    setTimeout(cb);
  }

  // eslint-disable-next-line class-methods-use-this
  outputUrl(url) {
    if (!hasHistorySupport()) {
      return;
    }

    if (url.indexOf('http') === 0) {
      window.history.replaceState(null, null, url);
      return;
    }

    window.history.replaceState(null, null, `?${url}`);
  }

  outputResults(results) {
    const resultsLabel = results === 1 ? app.i18n.product : app.i18n.products;
    this.resultsTarget.innerHTML = `${results} ${resultsLabel}`;
  }

  onSortChange() {
    this.onFilterChange();
  }
}

FiltersController.targets = [
  'form',
  'sortSelect',
  'products',
  'group',
  'results',
];

export default FiltersController;
